(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atable-cart-groups"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atable-cart-groups')) customElements.define('atable-cart-groups', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    const rows = [...this.querySelectorAll('[data-cart-line]')];
    if (!rows.length) return;
    this.ready = true;
    const groups = new Map();
    rows.forEach(row => {
      const group = groups.get(row.dataset.group) || [];
      group.push(row); groups.set(row.dataset.group, group);
    });
    const money = cents => new Intl.NumberFormat('en-GB', {style:'currency', currency:this.dataset.currency}).format(cents / 100);
    groups.forEach(lines => {
      if (lines.length < 2) return;
      const inputs = lines.map(line => line.querySelector('input[name="updates[]"]'));
      const quantity = inputs.reduce((sum,input) => sum + Number(input.value), 0);
      const original = lines.reduce((sum,line) => sum + Number(line.dataset.original), 0);
      const final = lines.reduce((sum,line) => sum + Number(line.dataset.final), 0);
      const card = lines[0].cloneNode(true);
      card.removeAttribute('data-cart-line'); card.classList.add('atable-cart-item--group');
      const control = card.querySelector('input[name="updates[]"]');
      control.removeAttribute('name'); control.id += '-group'; control.value = quantity;
      card.querySelector('label').htmlFor = control.id;
      card.querySelectorAll('.atable-cart-unit-price,.atable-cart-line-discount').forEach(node => node.remove());
      const summary = document.createElement('p');
      summary.className = 'atable-cart-group-summary'; summary.textContent = `${quantity} pieces`;
      card.querySelector('h2').after(summary);
      const total = card.querySelector('.atable-cart-item__total'); total.replaceChildren();
      const label = document.createElement('small'); label.textContent = 'Total'; total.append(label);
      if (original > final) { const before = document.createElement('s'); before.textContent = money(original); total.append(before); }
      const amount = document.createElement('strong'); amount.textContent = money(final); total.append(amount);
      if (original > final) {
        const saving = document.createElement('p'); saving.className = 'atable-cart-group-saving';
        saving.textContent = `Offer applied · Save ${money(original - final)}`; total.append(saving);
      }
      const sync = () => {
        if (!control.validity.valid) return;
        inputs.forEach((input,index) => { input.value = index === 0 ? control.value : '0'; });
        summary.textContent = 'Updating your cart…';
      };
      control.addEventListener('input', sync); control.addEventListener('change', sync);
      const remove = card.querySelector('[data-cart-remove]');
      remove.addEventListener('click', event => {
        event.preventDefault(); control.value = '0'; sync();
        const form = this.closest('form'); form.requestSubmit(form.querySelector('button[name="update"]'));
      });
      lines[0].before(card);
      lines.forEach(line => { line.hidden = true; line.setAttribute('aria-hidden','true'); });
    });
    const stockByVariant=new Map(rows.map(row=>{
      const info=row.querySelector('.atable-availability');
      return [Number(row.dataset.variantId),{stock:Number(info?.dataset.stock||0),byOrder:info?.dataset.byOrder==='true'}];
    }));
    const deliveryFor=(id,total)=>{const info=stockByVariant.get(Number(id));if(info?.byOrder&&total>info.stock)return 'Made to order · Expected delivery: 24–30 days';return Number(id)===50439299956839?'In stock · Expected delivery: 3–5 days':'In stock · Expected delivery: 5–7 days';};
    const form = this.closest('form');
    const checkout = form.querySelector('[name="checkout"]');
    const status = document.createElement('p');
    status.setAttribute('role','status'); status.setAttribute('aria-live','polite');
    this.append(status);
    const validateStock = () => {
      const totals=new Map();
      form.querySelectorAll('input[name="updates[]"]').forEach(input=>totals.set(input.dataset.variant,(totals.get(input.dataset.variant)||0)+Number(input.value)));
      let valid=true;
      form.querySelectorAll('.atable-quantity input').forEach(input=>{
        const limit=input.max===''?Infinity:Number(input.max);
        const row=input.closest('.atable-cart-item');
        const stockOK=(totals.get(input.dataset.variant)||0)<=limit;
        const availability=row?.querySelector('.atable-availability');
        if(availability){ const note=availability.querySelector('[data-order-message]'); if(note) note.hidden=!(availability.dataset.byOrder==='true' && (totals.get(input.dataset.variant)||0)>Number(availability.dataset.stock)); }
        if(!stockOK || !input.validity.valid) valid=false;
        const plus=row?.querySelector('[data-quantity-step="1"]');
        if(plus) plus.disabled=(totals.get(input.dataset.variant)||Number(input.value))>=limit;
      });
      if(checkout) checkout.disabled=!valid || this.busy || this.deliveryFailed;
      status.textContent=valid?'':'Please choose a lower quantity before checkout.';
      return valid;
    };
    validateStock();
    const update = async () => {
      clearTimeout(this.timer);
      if (this.busy) return;
      if (!form.reportValidity()) { validateStock(); return; }
      this.busy=true;
      const body=JSON.stringify({updates:[...form.querySelectorAll('input[name="updates[]"]')].map(input=>Number(input.value)),note:form.querySelector('[name="note"]')?.value || '',attributes:{'Delivery information':form.querySelector('[name="attributes[Delivery information]"]')?.value || ''},sections:['cart'],sections_url:new URL(form.action).pathname});
      const controls=[...form.querySelectorAll('button,input,textarea')];
      const states=controls.map(control=>control.disabled);
      controls.forEach(control=>control.disabled=true);
      form.setAttribute('aria-busy','true'); status.textContent='Updating your cart…';
      try {
        const response=await fetch(form.action.replace(/\/$/,'')+'/update.js',{method:'POST',body,headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin'});
        if(!response.ok) throw Error();
        let cart=await response.json();
        const limit=cart.items.length*2+3;
        for(let attempt=0;attempt<limit;attempt++){
          const totals=new Map();cart.items.forEach(item=>totals.set(item.variant_id,(totals.get(item.variant_id)||0)+item.quantity));
          const index=cart.items.findIndex(item=>stockByVariant.has(item.variant_id)&&item.properties?.Delivery!==deliveryFor(item.variant_id,totals.get(item.variant_id)));
          if(index<0){this.deliveryFailed=false;break;}
          if(attempt===limit-1)throw Error('Delivery update did not settle');
          const item=cart.items[index];
          const changed=await fetch(form.action.replace(/\/$/,'')+'/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({line:index+1,quantity:item.quantity,properties:{...item.properties,Delivery:deliveryFor(item.variant_id,totals.get(item.variant_id))},sections:['cart'],sections_url:new URL(form.action).pathname})});
          if(!changed.ok)throw Error('Delivery update failed');
          cart=await changed.json();
        }
        let html=cart.sections?.cart;
        if(!html){const page=await fetch(form.action,{credentials:'same-origin',cache:'no-store'});if(!page.ok)throw Error();html=await page.text();}
        const doc=new DOMParser().parseFromString(html,'text/html');
        const content=doc.querySelector('.atable-commerce');
        if(!content) throw Error();
        const headerCart=document.querySelector('.atable-header__cart');
        if(headerCart){headerCart.setAttribute('aria-label',`Cart with ${cart.item_count} items`);headerCart.querySelector('.atable-header__count')?.remove();if(cart.item_count){const count=document.createElement('span');count.className='atable-header__count';count.textContent=cart.item_count;headerCart.append(count);}}
        const pageCart=document.querySelector('#MainContent .atable-cart-layout')?.closest('.atable-commerce');
        if(pageCart && !pageCart.contains(this)) pageCart.replaceWith(content.cloneNode(true));
        this.closest('.atable-commerce').replaceWith(content);
      } catch {
        this.deliveryFailed=true;status.textContent='Could not update your cart. Please try Update again before checkout.';
      } finally {
        controls.forEach((control,index)=>control.disabled=states[index]);
        form.removeAttribute('aria-busy'); this.busy=false;
        if(this.isConnected) validateStock();
      }
    };
    const schedule = event => {
      if(!event.target.matches('.atable-quantity input')) return;
      if(!validateStock()) {clearTimeout(this.timer); return;}
      clearTimeout(this.timer); if(checkout) checkout.disabled=true;
      this.timer=setTimeout(update,150);
    };
    this.addEventListener('input',schedule); this.addEventListener('change',schedule);
    form.addEventListener('submit',event=>{
      if(event.submitter?.name==='checkout') {if(this.busy || this.deliveryFailed || !validateStock()){event.preventDefault();event.stopPropagation();} return;}
      event.preventDefault(); event.stopPropagation(); update();
    });
    const initialTotals=new Map();rows.forEach(row=>{const input=row.querySelector('input[name="updates[]"]');const id=Number(row.dataset.variantId);initialTotals.set(id,(initialTotals.get(id)||0)+Number(input.value));});
    if(rows.some(row=>row.dataset.delivery!==deliveryFor(Number(row.dataset.variantId),initialTotals.get(Number(row.dataset.variantId)))))update();
  }
  disconnectedCallback(){clearTimeout(this.timer);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atable-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('atable-product-gallery'))customElements.define('atable-product-gallery',class extends HTMLElement{
 connectedCallback(){
  this.events?.abort();this.events=new AbortController();
  this.slides=[...this.querySelectorAll('.atable-product__media-item')];
  this.thumbs=[...this.querySelectorAll('.atable-product__thumbnails a')];
  if(!this.slides.length)return;
  this.index=Math.max(0,this.slides.findIndex(s=>s.dataset.mediaId===this.dataset.initialMedia));
  this.dataset.ready='';
  const controls=this.querySelector('.atable-gallery-controls');if(controls)controls.hidden=false;
  this.addEventListener('click',e=>{
   const step=e.target.closest('[data-gallery-step]');
   if(step){this.show(this.index+Number(step.dataset.galleryStep));return}
   const thumb=e.target.closest('.atable-product__thumbnails a');
   if(thumb){e.preventDefault();const index=this.slides.findIndex(s=>'#'+s.id===thumb.getAttribute('href'));if(index>=0)this.show(index)}
  },{signal:this.events.signal});
  this.addEventListener('keydown',e=>{
   if(e.target.closest('input,textarea,select,video,iframe,model-viewer,[contenteditable=true]'))return;
   if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)||this.slides.length<2)return;
   e.preventDefault();
   const rtl=getComputedStyle(this).direction==='rtl';
   const next=e.key==='Home'?0:e.key==='End'?this.slides.length-1:this.index+(e.key==='ArrowRight'?(rtl?-1:1):(rtl?1:-1));
   this.show(next);
  },{signal:this.events.signal});
  this.show(this.index);
 }
 show(index){
  this.index=(index+this.slides.length)%this.slides.length;
  this.slides.forEach((slide,i)=>{
   const hidden=i!==this.index;
   if(hidden&&!slide.hidden){slide.querySelectorAll('video').forEach(v=>v.pause());slide.querySelectorAll('model-viewer').forEach(m=>m.pause?.());slide.querySelectorAll('iframe').forEach(f=>{const src=f.getAttribute('src');if(src)f.setAttribute('src',src)})}
   slide.hidden=hidden;
  });
  this.thumbs.forEach(a=>{if(a.getAttribute('href')==='#'+this.slides[this.index].id)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current')});
  const count=this.querySelector('[data-gallery-count]');if(count)count.textContent=`${this.index+1} / ${this.slides.length}`;
 }
 disconnectedCallback(){this.events?.abort()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atable-overlays"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('atable-overlays'))customElements.define('atable-overlays',class extends HTMLElement{
connectedCallback(){
 if(this.ready)return;this.ready=true;
 this.search=this.querySelector('#AtableSearch');this.cart=this.querySelector('#AtableCart');this.quick=this.querySelector('#AtableQuick');
 this.onClick=async e=>{
  const filter=e.target.closest('.atable-filter');
  document.querySelectorAll('.atable-filter[open]').forEach(item=>{if(item!==filter)item.open=false});
  const close=e.target.closest('[data-close]');if(close){close.closest('dialog').close();return}
  const open=e.target.closest('[data-atable-open]');if(open){e.preventDefault();const dialog=open.dataset.atableOpen==='cart'?this.cart:this.search;dialog.showModal();if(dialog===this.cart)await this.loadCart();return}
  const preview=e.target.closest('[data-showcase]');if(preview){e.preventDefault();this.quick.querySelector('[data-quick-content]').replaceChildren(preview.closest('article').querySelector('template').content.cloneNode(true));const detail=this.quick.querySelector('[data-product-link]');detail.hidden=!preview.dataset.showcase;if(preview.dataset.showcase)detail.href=preview.dataset.showcase;this.quick.showModal();return}
  const quick=e.target.closest('[data-atable-quick]');if(quick){e.preventDefault();this.quick.querySelector('[data-quick-content]').textContent=this.dataset.loading;const link=this.quick.querySelector('[data-product-link]');link.href=quick.dataset.atableQuick;link.hidden=false;this.quick.showModal();try{const doc=await this.page(quick.dataset.atableQuick,'product');const product=doc.querySelector('.atable-product');if(!product)throw Error();this.quick.querySelector('[data-quick-content]').replaceChildren(product)}catch{this.quick.close();location.assign(quick.dataset.atableQuick)}}
  const step=e.target.closest('[data-quantity-step]');if(step){const input=step.closest('.atable-quantity').querySelector('input');Number(step.dataset.quantityStep)>0?input.stepUp():input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));}
  const columns=e.target.closest('[data-columns]');if(columns){const section=columns.closest('.atable-commerce');section.style.setProperty('--atable-columns',columns.dataset.columns);section.querySelectorAll('[data-columns]').forEach(b=>b.setAttribute('aria-pressed',String(b===columns)))}
 };
 document.addEventListener('click',this.onClick);
 this.onKey=e=>{if(e.key==='Escape'){const active=document.activeElement.closest('.atable-filter');document.querySelectorAll('.atable-filter[open]').forEach(item=>item.open=false);active?.querySelector('summary').focus()}};
 document.addEventListener('keydown',this.onKey);
 this.querySelectorAll('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close()}}));
 const input=this.querySelector('#AtableOverlayQuery');
 input.addEventListener('input',()=>{clearTimeout(this.timer);this.abort?.abort();this.timer=setTimeout(()=>this.searchResults(input.value),250)});
 this.cart.addEventListener('submit',async e=>{
  if(e.submitter?.name==='checkout')return;
  const form=e.target;if(!form.matches('form'))return;e.preventDefault();const body=new FormData(form);
  const buttons=this.cart.querySelectorAll('button');buttons.forEach(b=>b.disabled=true);
  try{const response=await fetch(form.action,{method:'POST',body,credentials:'same-origin'});if(!response.ok)throw Error();const doc=new DOMParser().parseFromString(await response.text(),'text/html');this.replaceCart(doc)}catch{location.assign(this.dataset.cart)}finally{buttons.forEach(b=>b.disabled=false)}
 });
}
async page(path,section,signal){const url=new URL(path,location.origin);url.searchParams.set('section_id',section);const response=await fetch(url,{signal,credentials:'same-origin'});if(!response.ok)throw Error();return new DOMParser().parseFromString(await response.text(),'text/html')}
replaceCart(doc){const content=doc.querySelector('.atable-commerce');if(!content)throw Error();this.querySelector('[data-cart-content]').replaceChildren(content)}
async loadCart(){this.querySelector('[data-cart-content]').textContent=this.dataset.loading;try{this.replaceCart(await this.page(this.dataset.cart,'cart'))}catch{this.cart.close();location.assign(this.dataset.cart)}}
async searchResults(value){const results=this.querySelector('.atable-overlay-results'),curated=this.querySelector('.atable-search-curated');const url=new URL(this.dataset.search,location.origin);url.searchParams.set('q',value);this.querySelector('[data-results-link]').href=url;
 if(!value.trim()){results.replaceChildren();curated.hidden=false;return}
 this.abort=new AbortController();try{const doc=await this.page(url,'search',this.abort.signal);const match=doc.querySelector('.atable-grid')||doc.querySelector('.atable-empty');results.replaceChildren(...(match?[match]:[]));curated.hidden=true}catch(e){if(e.name!=='AbortError'){results.textContent=this.dataset.error;curated.hidden=false}}
}
disconnectedCallback(){document.removeEventListener('click',this.onClick);document.removeEventListener('keydown',this.onKey);clearTimeout(this.timer);this.abort?.abort()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["atable-restock-brand"] && !Shopify.designMode) return;
  try {
    const restockBrand = document.querySelector('[data-restock-brand]');
if (restockBrand) {
  const brand = () => {
    document.querySelectorAll('.restock-alerts-modal-title').forEach(node => { if(!node.dataset.atableBranded){node.dataset.atableBranded='true';node.textContent = restockBrand.dataset.title;} });
    document.querySelectorAll('.restock-alerts-modal-description').forEach(node => { if(!node.dataset.atableBranded){node.dataset.atableBranded='true';node.textContent = restockBrand.dataset.description;} });
  };
  brand();
  new MutationObserver(brand).observe(document.body,{childList:true,subtree:true});
}
  } catch(e) { console.error(e); }
})();

})();
